import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { marked } from "marked";
import { ArrowRight } from "@phosphor-icons/react";
import SEOHead from "../components/SEOHead";
import { SPALink } from "../context/NavigationContext";
import { getLegalContent } from "../data/legal";
import { sanitizeHtml } from "../utils/sanitize";

marked.setOptions({ breaks: true, gfm: true });

const PolitiqueConfidentialitePage = () => {
  const { i18n } = useTranslation();
  const content = getLegalContent(i18n.language);
  const page = content.politiqueConfidentialite;
  const html = useMemo(
    () => ({ __html: sanitizeHtml(marked.parse(page.body)) }),
    [page.body]
  );

  return (
    <main role="main" aria-label={page.title} className="min-h-screen bg-lumina-dark pt-20">
      <SEOHead
        title={page.seoTitle}
        description={page.seoDescription}
        path="/politique-confidentialite"
        noindex={true}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="privacy-banner">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-3">{page.title}</h1>
        <p className="text-gray-500 text-sm mb-12">{content.meta.lastUpdated}</p>

        <article
          className="prose prose-invert prose-violet max-w-none legal-prose"
          // Content sanitized upstream via `sanitizeHtml` (DOMPurify strict allowlist).
          // See /app/frontend/src/utils/sanitize.js for the mitigation.
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={html}
        />

        <div className="mt-12 pb-4">
          <SPALink to="/" className="inline-flex items-center gap-2 text-lumina-violet hover:text-white transition-colors font-medium" data-testid="privacy-back-home">
            <ArrowRight size={16} weight="bold" className="rotate-180" />
            {content.meta.backToHome}
          </SPALink>
        </div>
      </div>
    </main>
  );
};

export default PolitiqueConfidentialitePage;
